export default __webpack_public_path__ + "static/media/service-banner.e817018d.png";